import { FileDownloadOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";
import { useLazyListPendingPaymentsForReportsQuery } from "store/services/reportApi";
import { exportExcelFile } from "utils/exportExcelFile";

const ExportPendingPaymentsReportExcel = ({ responsibleUser, chargeType }) => {
  const [fetchPendingPayments, { isLoading, isFetching }] =
    useLazyListPendingPaymentsForReportsQuery();

  const handleDownload = async () => {
    try {
      const responseData = await fetchPendingPayments({
        page: 1,
        limit: 10000,
        chargeType,
        ...(responsibleUser &&
          responsibleUser !== "all" && { responsibleUser }),
      }).unwrap();

      if (!responseData?.data || responseData.data.length === 0) {
        toast.info("No data.");
        return;
      }

      const formattedData = responseData.data.map((row, index) => ({
        SN: index + 1,
        "Responsible User": row.responsibleUserName || "N/A",
        "Payment Type": row.pendingType || "N/A",
        Amount: row.pendingAmount ? Number(row.pendingAmount) : 0,
      }));

      exportExcelFile({
        sheetData: formattedData,
        fileName:
          chargeType === "Charge"
            ? "Pending_Charge_Report"
            : "Pending_COD_Report",
      });
      toast.success("Data downloaded successfully");
    } catch (error) {
      toast.error(
        "Error fetching pending payments report data: " + error.message
      );
    }
  };

  return (
    <div>
      <Tooltip title="Export Excel" arrow>
        <IconButton
          color="success"
          onClick={handleDownload}
          disabled={isLoading || isFetching}
        >
          <FileDownloadOutlined />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default ExportPendingPaymentsReportExcel;